import React from 'react';
import PropTypes from 'prop-types';

const STYLE_PREFIX = 'c-consent-modal';

const ConsentToggle = ({ toggleName, checked, onChange }) => {
  return (
    <label
      className={`${STYLE_PREFIX}__switch`}
      aria-label={`toggle ${toggleName} consent`}
    >
      <input type="checkbox" onChange={onChange} checked={checked} />
      <span className={`${STYLE_PREFIX}__slider round`} />
    </label>
  );
};

ConsentToggle.propTypes = {
  toggleName: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ConsentToggle;
